<template>
    <div class="card" style="margin-top: 40px; padding: 0;background-color: rgb(236 249 253 / 65%);">
        <div class="card-body" style="padding: 0px 0px 10px 0px;">
            <button @click="closeModal" class="closeIcon" style="width: 40px;height: 40px;"><span></span></button>
            <div class="container">
                <div class=" row" v-if="isLoading">
                    <Loader class="col-12"></Loader>
                </div>
                <div class="row" v-else>
                    <template v-if="calculator.length == 0">
                        <div class="col-12 text-center" style="padding: 20px;">
                            <h3 class="title_table">No Record.</h3>
                        </div>
                    </template>
                    <template v-else>
                        <div class="col-6"
                        style="border-right: 3px solid #ddd; position: relative; overflow: hidden; overflow-y:auto; height: calc(100vh - 55px);padding: 0 15px 0 0;">
                            <div class="header_table" v-if="calculator.length">
                                <h3 class="title_table" v-if="calculator[0].name">{{ calculator[0].name }}</h3>
                                <span v-if="fromWhatView==='estimate'" style="position: absolute; top:10px; left:0; z-index: 2; font-size: 0.75rem; line-height:1; padding: 4px 10px;  text-shadow:none; font-weight:200;border:1px solid #ddd; border-radius:5px; background-color: #f3fbfe;">
                                    <span >From Estimate: </span>
                                    <span style="margin-left:10px;font-weight:700;font-size: 1rem;">${{ calculator[0].estimate.total | formatMoney }}</span>
                                </span>
                                <span v-else style="position: absolute; top:10px; left:0; z-index: 2; font-size: 0.75rem; line-height:1; padding: 4px 10px;  text-shadow:none; font-weight:200;border:1px solid #ddd; border-radius:5px; background-color: #f3fbfe;">
                                    <span >From Invoice: </span>
                                    <span style="margin-left:10px;font-weight:700;font-size: 1rem;">${{ calculator[0].invoice.total | formatMoney }}</span>
                                </span>
                                <button class="btn btn-xs btn-ligth" style="position: absolute; top:5px; right:0; z-index: 2;" @click="setClone(calculator[0])" v-if="cloneData.inactiveRealCost">
                                    <i class="far fa-copy"></i> Copy data to right
                                    <i class="fas fa-arrow-right"></i>
                                </button>
                            </div>
                            <calcCosts v-if="calculator[0]" :propData="calculator[0]" :fwv="fromWhatView"></calcCosts>
                        </div>
                        <div class="col-6"
                        v-if="calculator.length == 2"
                        style=" border-left: 3px solid #ddd; position: relative; overflow: hidden; overflow-y:auto; padding: 0 0 0 10px;overflow-y:auto; height: calc(100vh - 55px);">
                            <div v-if="cloneData.inactiveRealCost" style="background-color: rgb(192 253 233 / 58%); position: absolute; width: 100%; height: 100%; top:0; left:0; z-index: 5;"></div>
                            <div class="header_table" style="">
                                <h3 class="title_table" v-if="calculator[1].name">{{ calculator[1].name }}</h3>
                            </div>
                            <realCosts v-if="calculator[1]" :propData="calculator[1]" :cloneTable="cloneTable" :fwv="fromWhatView"></realCosts>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import calcCosts from './calcCosts.vue';
import realCosts from './realCosts.vue';
import Loader from '@/core/components/shared/Loader';
export default {
    name: 'calcManual',
    components: {
        Loader,
        calcCosts,
        realCosts,
    },
    data() {
        return {
            // Add any data properties needed for the estimator setup
            calculator: [],
            document_id: 0,
            isLoading: false,
            cloneData: {
                clone: false,
                inactiveRealCost: true,
                data_id: 0,
            },
            cloneTable: null,
            fromWhatView: null
        };
    },
    mounted() {
        this.$store.commit("ModApps/billing/setVisibleAside", {'vista':'setting', 'aside': true});
        this.document_id = this.$store.getters['ModApps/billing/getPopCalculator'].data.document_id || 0;
        this.fromWhatView = this.$store.getters['ModApps/billing/getPopCalculator'].data.fwv || 'estimate';
        this.getCalculator();
    },
    methods: {
        setClone(data){
            this.cloneData.clone = true;
            this.cloneData.inactiveRealCost = false;
            this.cloneData.data_id = data.id;
            this.cloneTable = this.cloneData;
        },
        // Define methods for handling estimator setup logic
        closeModal() {
            // Logic to save settings
            this.$parent.$parent.closeModal()
        },
        getCalculator() {
            // Logic to retrieve the template data
            this.isLoading = true;
            let getUrl = 'calcestimate/get';
            if(this.fromWhatView === 'invoice') getUrl = 'calcinvoice/get';
            console.log('fromWhatView', this.fromWhatView)
            window.billing.post(getUrl, {
                user_id: window.master_client,
                org_id: window.localorgdata,
                id: this.document_id,
            }).then((response) => {
                console.log('Template data fetched:', response.data);
                this.$store.commit("core/setNotiPushDestroyAll");
                this.calculator = response.data;
                if(this.calculator.length == 2){
                    if(this.calculator[1].calc_type == 'real_cost' && this.calculator[1].categories_with_items.length > 0){
                        this.cloneData.inactiveRealCost = false;
                    }
                }
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;
                console.error('Error fetching template:', error);
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.closeIcon span:before,
.closeIcon span:after {
    width: 37px;
}
.header_table{
    border-bottom: 1px solid #ddd;
    position: sticky;
    top: 0;
    background: #f3fbfe;
    z-index: 2;
    padding: 10px 0 0 0;
    margin: 0 0 10px 0;
}
.title_table{
    font-size: 2em;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: center;
    line-height: 1em;
}

</style>
